import { AxiosPromise, AxiosResponse } from "axios";
import { httpClient } from "src/shared/services/httpClient";
import {
  TGetPublicCertificateDownloadFormParams,
  TSubmitPublicCertificateDownloadFormParams,
} from "../types";

export const getPublicCertificateDownloadFormParams =
  (): AxiosPromise<TGetPublicCertificateDownloadFormParams> =>
    httpClient.get("/publicCertificateDownload/form");
export const submitPublicCertificateDownloadForm = (
  data: TSubmitPublicCertificateDownloadFormParams,
): AxiosPromise<AxiosResponse<any>> =>
  httpClient.post("/publicCertificateDownload/getCertificate", data, {
    responseType: "blob",
  });
